import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { definition as faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import defaultGroups from "./defaultGroups";
import defaultApplySettings from "./defaultApplySetting";
import { defaultGetSettings } from "./cookie";
import ActionButton from "./ActionButton";
import SettingsGroup from "./SettingsGroup";
import useSettigs from "./useSettings";
import { settingsPanel, settingsPanelGroups, settingsPanelButtons, settingsPanelButtonsRight } from "./classNames";
import { groupsArrayOf } from "./propTypes";
var SettingsPanel = memo(function (_ref) {
  var groups = _ref.groups,
      getSettings = _ref.getSettings,
      restoreButtonText = _ref.restoreButtonText,
      closeButtonText = _ref.closeButtonText,
      handleClose = _ref.handleClose,
      applySetting = _ref.applySetting;

  var _useSettigs = useSettigs({
    getSettings: getSettings,
    groups: groups,
    applySetting: applySetting
  }),
      values = _useSettigs.values,
      setValue = _useSettigs.setValue,
      handleRestore = _useSettigs.handleRestore;

  return React.createElement("div", {
    className: settingsPanel
  }, React.createElement("div", {
    className: settingsPanelGroups
  }, groups.map(function (group) {
    var property = group.property;
    return React.createElement(SettingsGroup, {
      group: group,
      value: values[property],
      setValue: setValue,
      key: group.property
    });
  })), React.createElement("div", {
    className: settingsPanelButtons
  }, React.createElement("div", {
    className: settingsPanelButtonsRight
  }, React.createElement(ActionButton, {
    onClick: handleClose
  }, closeButtonText)), React.createElement(ActionButton, {
    onClick: handleRestore
  }, React.createElement(FontAwesomeIcon, {
    icon: faSync,
    rotation: 90,
    size: "xs",
    fixedWidth: true
  }), ' ', restoreButtonText)));
});
SettingsPanel.propTypes = {
  groups: groupsArrayOf,
  getSettings: PropTypes.func,
  restoreButtonText: PropTypes.string,
  closeButtonText: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  applySetting: PropTypes.func
};
SettingsPanel.defaultProps = {
  groups: defaultGroups,
  getSettings: defaultGetSettings,
  restoreButtonText: 'Вернуть стандартные настройки',
  closeButtonText: 'Закрыть панель',
  applySetting: defaultApplySettings
};
export default SettingsPanel;